import { 
  // pnrFrequentFlyerNumber,
  pnrTicketNumber,
  createValidator,
  lastName,
  lastNamePvf,
  reservationTicketNumber,
  pnrFFN,
} from './validation';

const pnrLookupValidationFields = {
  lastName: [lastName],
  // frequentFlyerNumber: [pnrFrequentFlyerNumber],
  ticketNumber: [pnrTicketNumber],
  reservationTicketNumber: [reservationTicketNumber],
  frequentFlyerNumberHM: [pnrFFN],
  lastNamePvf: [lastNamePvf],
};

const pnrLookupValidator = createValidator(pnrLookupValidationFields);

const pnrLookupValidation = values => {
  return pnrLookupValidator(values);
};

export default pnrLookupValidation;